<template>
  <v-main class="fill-height">
    <v-container v-if="loading" class="d-flex justify-center align-center">
      <v-progress-circular indeterminate color="primary" size="50" />
    </v-container>

    <v-container v-else-if="error">
      <v-alert type="error" dense>{{ error }}</v-alert>
    </v-container>

    <v-container v-else class="mt-6 mb-6">
      <v-row>
        <v-col cols="5">
          <v-img :src="require('@/assets/meeting.svg')" contain />
        </v-col>

        <v-col cols="7">
          <h1 class="font-bold mb-4">Você foi convidado para um ato/evento!</h1>

          <p class="mb-6">
            <strong>{{ meeting.name }}</strong
            ><br />
            <strong>Data:</strong> {{ meeting.date }}<br />
            <strong>Formato:</strong> {{ meeting.format === 1 ? 'Digital' : 'Presencial' }}<br />
            <span v-if="meeting.format === 1"><strong>Link:</strong> {{ meeting.location }}</span>
            <span v-if="meeting.format === 2"><strong>Local:</strong> {{ meeting.location }}</span>
          </p>
          <p class="mb-6">
            <strong>Convidado:</strong>
            {{ meeting.signer.name ? meeting.signer.name : meeting.signer.business_name }}<br />
            <strong>Email:</strong> {{ meeting.signer.email }}<br />
          </p>

          <v-btn
            :disabled="meeting.participant.status === 'confirmed' || actionLoading"
            color="primary"
            large
            @click="confirm('confirmed')"
          >
            <span v-if="actionLoading">Processando...</span>
            <span v-else>
              {{
                meeting.participant.status === 'confirmed'
                  ? 'Presença Confirmada'
                  : 'Confirmar Presença'
              }}
            </span>
          </v-btn>

          <v-btn
            :disabled="meeting.participant.status === 'recused' || actionLoading"
            class="ml-4"
            color="error"
            large
            @click="confirm('recused')"
          >
            <span v-if="actionLoading">Processando...</span>
            <span v-else>Recusar Convite</span>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" v-if="meeting.term">
          <h2 class="mt-6 mb-4">Termo de Convocação</h2>
          <v-card flat outlined>
            <vue-pdf-embed
              v-if="pdfSource"
              class="pdf-container"
              justify="center"
              :source="`data:application/pdf;base64, ${pdfSource}`"
            />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';

export default {
  name: 'ConfirmationMeetingPage',
  components: {
    VuePdfEmbed,
  },
  data() {
    return {
      meeting: null,
      loading: true,
      error: null,
      actionLoading: false,
      pdfSource: null,
    };
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.loading = true;

      try {
        const data = await this.$store.dispatch('meeting/details', {
          id: this.$route.params.id,
          token: this.$route.params.token,
        });

        this.meeting = data;

        if (this.meeting?.term?.id) {
          await this.fetchTermPreview();
        }
      } catch (error) {
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },

    async fetchTermPreview() {
      try {
        const response = await this.previewTerm(this.meeting.term);

        this.pdfSource = response;
      } catch (error) {
        this.$toasted.error('Erro ao carregar o termo de convocação');
      }
    },

    async previewTerm(term) {
      try {
        return await this.$store.dispatch('document/getTerm', {
          id: term.id,
          folder: term.folder,
          filename: term.filename,
        });
      } catch (error) {
        this.$toasted.error('Erro ao visualizar o documento');
        throw error;
      }
    },

    async confirm(status) {
      this.actionLoading = true;

      try {
        await this.$store.dispatch('meeting/confirm', {
          id: this.meeting.participant.id,
          status,
        });

        const verb = status === 'confirmed' ? 'confirmou' : 'recusou';
        this.$toasted.success(`Você ${verb} sua presença no ato/evento.`);

        await this.initialize();
      } catch (err) {
        this.$toasted.error(err.message || 'Erro ao registrar sua resposta.');
      } finally {
        this.actionLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.pdf-container {
  width: 100%;
  height: 480px;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
}
</style>
